import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'services/api';

import { Types as SectionsTypes, Creators as SectionsActions } from 'store/ducks/sections';

function* searchSectionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/sections?search=${query}&per=100`;
    const response = yield call(api.get, url);

    yield put(SectionsActions.searchSectionsSuccess(response.data));
  } catch (error) {
    yield put(SectionsActions.searchSectionsFailure());
  }
}

export default function* saga() {
  yield takeLatest(SectionsTypes.SEARCH_REQUEST, searchSectionsRequest);
}
